"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("../../core");
var is_primitive_1 = require("../../core/lang/is-primitive");
var i_st_1 = require("../../core/st/interface/i$st");
var component_1 = require("../component");
var tsx_1 = require("./tsx");
var iattributes_1 = require("./interface/iattributes");
var type_function_1 = require("../../core/lang/type-function");
var type_string_1 = require("../../core/lang/type-string");
var type_boolean_1 = require("../../core/lang/type-boolean");
var immute_1 = require("../../core/lang/immute");
var type_undefined_1 = require("../../core/lang/type-undefined");
var attr_1 = require("../component/trait/attr");
// name of the standard component attribute to pass a map of attributes at once
// like: <Bar attrs={{ hidden: true, foo: '123', ... }} /> instead of writing
// <Bar hidden={true} foo='123' />
exports.ATTRS_ATTR_NAME = "attrs";
exports.TEMPLATE_ELEMENT_NAME = "template";
exports.DEFAULT_SLOT_NAME = "default";
exports.FRAGMENT_ELEMENT_NAME = "fragment";
exports.CLASS_ATTRIBUTE_NAME = "class";
exports.STYLE_ATTRIBUTE_NAME = "style";
exports.TABINDEX_ATTRIBUTE_NAME = "tabindex";
exports.CLASS_NAME_ATTRIBUTE_NAME = "className";
exports.XLINK_ATTRIBUTE_NAME = "xlink";
exports.ID_ATTRIBUTE_NAME = "id";
exports.LIST_KEY_ATTRIBUTE_NAME = "key";
exports.DISABLED_ATTRIBUTE_NAME = "disabled";
exports.ATTR_EVENT_LISTENER_PREFIX = "on";
exports.ATTR_DEBUG_PREFIX = "__";
exports.ATTR_ST_HIDE = "st-hide";
var SVG_NAMESPACE = "http://www.w3.org/2000/svg";
var STANDARD_HTML_PASS_ATTRIBUTES = [
    exports.CLASS_ATTRIBUTE_NAME,
    exports.STYLE_ATTRIBUTE_NAME,
    exports.ID_ATTRIBUTE_NAME,
    exports.TABINDEX_ATTRIBUTE_NAME,
    exports.LIST_KEY_ATTRIBUTE_NAME,
    exports.DISABLED_ATTRIBUTE_NAME
];
if (!core_1.st.dom) {
    // DOM abstraction layer for manipulation
    core_1.st.dom = {
        isReady: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (document.body)
                    return [2 /*return*/, Promise.resolve()];
                return [2 /*return*/, new Promise(function (resolve) { return document.addEventListener("DOMContentLoaded", function () { return resolve(); }); })];
            });
        }); },
        hasElNamespace: function (domElement) {
            return domElement.namespaceURI === SVG_NAMESPACE;
        },
        hasSvgNamespace: function (parentElement, type) {
            return core_1.st.dom.hasElNamespace(parentElement) && type !== "STYLE" && type !== "SCRIPT";
        },
        isRegisteredComponent: function (tagName) { return !!core_1.st[i_st_1.GlobalCache.COMPONENT_REGISTRY][tagName]; },
        createElementOrElements: function (virtualNode, parentDomElement, detached) {
            if (detached === void 0) { detached = false; }
            if (Array.isArray(virtualNode)) {
                return core_1.st.dom.createChildElements(virtualNode, parentDomElement, detached);
            }
            else if (typeof virtualNode != type_undefined_1.TYPE_UNDEFINED) {
                return core_1.st.dom.createElement(virtualNode, parentDomElement, detached);
            }
            else {
                // undefined virtualNode -> e.g. when a tsx variable is used in markup which is undefined
                return core_1.st.dom.createTextNode("", parentDomElement, detached);
            }
        },
        createComponentInstance: function (virtualNode, parentDomElement) {
            // Refactor: exclude
            var component;
            var componentCtor = core_1.st.getComponent(virtualNode.type);
            if (!componentCtor)
                return {};
            var outerAttributes = immute_1.cloneObject(virtualNode.attributes, false);
            // identified virtual component
            // functional component
            if (!componentCtor.name) {
                var fn = componentCtor;
                // create shallow component instance
                component = new component_1.Component();
                if (componentCtor.functionalName) {
                    fn.COMPONENT_OPTIONS.tag = componentCtor.functionalName;
                }
                // assign options
                component.INTERNAL.options = fn.COMPONENT_OPTIONS;
                // execute function and assign render method
                component.render = fn(component);
            }
            else {
                // class API
                // create instance of component
                component = new componentCtor();
                if (process.env.NODE_ENV == 'development') {
                    if (!(component instanceof core_1.st.component)) {
                        core_1.st.error("Class " + componentCtor.name + " does not extend from st.component!");
                    }
                }
            }
            // set root DOM node ref and parent ref
            component.parent = parentDomElement.$stComponentRef;
            // assign attributes, slotChildren etc.
            component.virtualNode = virtualNode;
            if (component.parent) {
                if (!component.parent.childComponents) {
                    component.parent.childComponents = [];
                }
                component.parent.childComponents.push(component);
            }
            var _loop_1 = function (propName) {
                // undefined early return
                if (typeof component[propName] == type_undefined_1.TYPE_UNDEFINED)
                    return "continue";
                if (propName.startsWith(exports.ATTR_EVENT_LISTENER_PREFIX) &&
                    typeof component[propName] == type_function_1.TYPE_FUNCTION) {
                    // component-local bound event listener function
                    if (!virtualNode.attributes) {
                        virtualNode.attributes = {};
                    }
                    // e.g. onClick
                    if (outerAttributes[propName]) {
                        var outsideEventListener_1 = outerAttributes[propName];
                        var localEventListener_1 = component[propName];
                        // makes sure that first onClick (inner class impl) is called
                        // and afterwards outer registered onClick with the same event,
                        // no matter if the event was stopped by the inner class impl.
                        virtualNode.attributes[propName] = function (evt) {
                            localEventListener_1(evt);
                            outsideEventListener_1(evt);
                        };
                    }
                    else {
                        virtualNode.attributes[propName] = component[propName];
                    }
                }
            };
            for (var propName in component) {
                _loop_1(propName);
            }
            // to analyze, filter and transform before create
            component.onBeforeElCreate(virtualNode);
            return {
                component: component,
                componentCtor: componentCtor,
                outerAttributes: outerAttributes
            };
        },
        getTagToUse: function (component, virtualNode) {
            if (component) {
                if (component.tag || component.INTERNAL.options && component.INTERNAL.options.tag) {
                    // use <class-name> instead of ClassName which would end up as <classname> in DOM
                    return component.tag || component.INTERNAL.options.tag;
                }
            }
            // support for <component tag="h1"> and <div tag="h2"> cases
            if (virtualNode.attributes && virtualNode.attributes.tag) {
                return virtualNode.attributes.tag;
            }
            return virtualNode.type;
        },
        createElement: function (virtualNode, parentDomElement, detached) {
            if (detached === void 0) { detached = false; }
            var newEl;
            var setComponentAttr = function (name) {
                var value = outerAttributes[name] || component.INTERNAL[name];
                if (typeof value !== type_undefined_1.TYPE_UNDEFINED) {
                    virtualNode.attributes[name] =
                        component.INTERNAL[name] =
                            component[name] = value;
                }
            };
            var _a = core_1.st.dom.createComponentInstance(virtualNode, parentDomElement), component = _a.component, outerAttributes = _a.outerAttributes;
            if (virtualNode.type.toUpperCase() === "SVG" || core_1.st.dom.hasSvgNamespace(parentDomElement, virtualNode.type.toUpperCase())) {
                newEl = document.createElementNS(SVG_NAMESPACE, virtualNode.type);
            }
            else {
                newEl = document.createElement(core_1.st.dom.getTagToUse(component, virtualNode));
            }
            if (component) {
                // set element reference
                component.el = newEl;
                // reference component logical controller component
                newEl.$stComponent = component;
                newEl.$stComponentRef = component;
                newEl.getComponent = function () {
                    return this.$stComponent || this.$stComponentRef;
                };
                // any internal  @attr(AttrType.DOM_TRANSPARENT) foo = 123; or outer foo={123} handling
                for (var attrName in component.INTERNAL.attributes) {
                    if (attr_1.AttrTrait.getType(component, attrName) == attr_1.AttrType.DOM_TRANSPARENT) {
                        var value = outerAttributes[attrName] || component.INTERNAL.attributes[attrName];
                        virtualNode.attributes[attrName] = value;
                        // update as a decision
                        component.INTERNAL.attributes[attrName] = value;
                    }
                }
                setComponentAttr(exports.DISABLED_ATTRIBUTE_NAME);
                setComponentAttr(exports.LIST_KEY_ATTRIBUTE_NAME);
                setComponentAttr(exports.TABINDEX_ATTRIBUTE_NAME);
                setComponentAttr(exports.ID_ATTRIBUTE_NAME);
            }
            else {
                // passing down parent component reference (it's a pure DOM element in this case)
                newEl.$stComponentRef = parentDomElement.$stComponentRef;
                newEl.getComponent = function () {
                    return this.$stComponentRef;
                };
            }
            if (virtualNode.attributes) {
                core_1.st.dom.setAttributes(virtualNode.attributes, newEl);
            }
            if (component) {
                // to verify and mutate further
                component.onAfterElCreate(newEl);
                component.onBeforeElChildrenCreate();
            }
            if (virtualNode.children) {
                core_1.st.dom.createChildElements(virtualNode.children, newEl);
            }
            if (component) {
                component.onAfterElChildrenCreate();
                component.onBeforeConnect();
            }
            if (!detached) {
                parentDomElement.appendChild(newEl);
                if (component) {
                    component.connectedCallback();
                }
            }
            return newEl;
        },
        replaceElement: function (virtualNode, parentDomElement, oldDomChildElement) {
            var domElement = core_1.st.dom.createElement(virtualNode, parentDomElement, true);
            parentDomElement.replaceChild(domElement, oldDomChildElement);
            return domElement;
        },
        replaceTextNode: function (virtualElementTextContent, parentDomElement, oldDomChildElement) {
            var domElement = core_1.st.dom.createTextNode(virtualElementTextContent, parentDomElement, true);
            parentDomElement.replaceChild(domElement, oldDomChildElement);
            return domElement;
        },
        createTextNode: function (text, domElement, detached) {
            if (detached === void 0) { detached = false; }
            var node = document.createTextNode(text.toString());
            if (!detached) {
                domElement.appendChild(node);
            }
            return node;
        },
        createChildElements: function (virtualChildren, domElement, detached) {
            if (detached === void 0) { detached = false; }
            var children = [];
            for (var _i = 0, _a = virtualChildren; _i < _a.length; _i++) {
                var virtualChild = _a[_i];
                if (is_primitive_1.isPrimitive(virtualChild)) {
                    children.push(core_1.st.dom.createTextNode(((typeof virtualChild == type_undefined_1.TYPE_UNDEFINED || virtualChild === null) ? "" : virtualChild).toString(), domElement, detached));
                }
                else {
                    if (tsx_1.isJSXComment(virtualChild)) {
                        continue;
                    }
                    children.push(core_1.st.dom.createElement(virtualChild, domElement, detached));
                }
            }
            return children;
        },
        setAttribute: function (name, value, domElement, forceNative) {
            // don't render debug attributes like __source and __self
            if (name.indexOf(exports.ATTR_DEBUG_PREFIX) === 0)
                return;
            // attributes not set (undefined) are ignored; use null value to reset an attributes state
            if (typeof value == type_undefined_1.TYPE_UNDEFINED)
                return;
            // implementation to pass a map of attributes at once
            // like: <input attrs={{ hidden: true, value: '123', ... }} /> instead of writing
            // <input hidden={true} value='123' />
            if (name === exports.ATTRS_ATTR_NAME) {
                for (var attrName in value) {
                    core_1.st.dom.setAttribute(attrName, value[attrName], domElement, forceNative);
                }
                return;
            }
            // stores referenced DOM nodes in a memory efficient WeakMap
            // for access from CustomElements
            if (name === iattributes_1.REF_ATTRIBUTE_NAME) {
                var refName = Object.keys(value)[0];
                if (!domElement.$stComponentRef.INTERNAL.refs) {
                    domElement.$stComponentRef.INTERNAL.refs = {};
                }
                var refValue = domElement.$stComponent || domElement;
                // remember for destruction on disconnect
                domElement.$stComponentRef.INTERNAL.refs[refName] = refValue;
                var refMutation = false;
                if (value[refName][refName]) {
                    refMutation = true;
                }
                Object.defineProperty(value[refName], refName, {
                    value: refValue,
                    configurable: true,
                });
                if (refMutation) {
                    value[refName].onAfterRefChange(refName, refValue);
                }
                return;
            }
            if (name.startsWith(exports.ATTR_EVENT_LISTENER_PREFIX) && typeof value == type_function_1.TYPE_FUNCTION) {
                var eventName = name.substring(2).toLowerCase();
                var capturePos = eventName.indexOf("capture");
                var doCapture = capturePos > -1;
                // onClickCapture={...} support
                if (doCapture) {
                    eventName = eventName.substring(0, capturePos);
                }
                domElement.addEventListener(eventName, value, doCapture);
                return;
            }
            // transforms class={['a', 'b']} into class="a b"
            if (name === exports.CLASS_ATTRIBUTE_NAME && Array.isArray(value)) {
                value = value.join(" ");
            }
            if (core_1.st.dom.hasElNamespace(domElement) && name.startsWith(exports.XLINK_ATTRIBUTE_NAME)) {
                domElement.setAttributeNS("http://www.w3.org/1999/xlink", tsx_1.tsxToStandardAttributeName(name), value);
            }
            else {
                if (domElement.$stComponent && !core_1.st.dom.isStandardHTMLAttribute(name) && forceNative !== true) {
                    domElement.$stComponent.setAttribute(name, value);
                }
                else if (name === exports.STYLE_ATTRIBUTE_NAME && typeof value !== type_string_1.TYPE_STRING) {
                    for (var prop in value) {
                        domElement.style[prop] = value[prop];
                    }
                }
                else {
                    if (typeof value == type_boolean_1.TYPE_BOOLEAN) {
                        domElement[name] = value;
                    }
                    else {
                        domElement.setAttribute(name, value);
                    }
                }
            }
        },
        isStandardHTMLAttribute: function (name) {
            // these attributes, set on a component (from the outside) will
            // always directly be set on component.el and the component will
            // not be notified using lifecycle methods
            // thus, these attribute names render pointless to be used
            // but this should be obvious too - just because of thier names nature
            return STANDARD_HTML_PASS_ATTRIBUTES.indexOf(name.toLowerCase()) > -1;
        },
        setAttributes: function (attributes, domElement, forceNative) {
            for (var name_1 in attributes) {
                core_1.st.dom.setAttribute(name_1, attributes[name_1], domElement, forceNative);
            }
        },
        /**
         * Only sets the non-standard st-hide attribute on the DOM element given.
         * You need a global CSS style declaration like: [st-hide] { display: none }
         * for this to work properly.
         */
        hide: function (domElement) {
            domElement.setAttribute(exports.ATTR_ST_HIDE, '');
        },
        /**
         * Removes the non-standard st-hide attribute from the DOM element given.
         */
        show: function (domElement) {
            domElement.removeAttribute(exports.ATTR_ST_HIDE);
        },
        /**
         * Removes the DOM element provided from it's parent.
         */
        removeElement: function (domElement) {
            if (domElement.parentNode) {
                domElement.parentNode.removeChild(domElement);
            }
        },
        /**
         * Removes all children of a DOM element.
         * Behaves the same like element.innerHTML = '';
         */
        removeChildren: function (domElement) {
            while (domElement.firstChild) {
                domElement.removeChild(domElement.firstChild);
            }
        },
        /**
         * Removes a CSS class from a DOM elements classList.
         */
        addClass: function (className, domElement) {
            domElement.classList.add(className);
        },
        /**
         * Adds a CSS class from a DOM elements classList.
         */
        removeClass: function (className, domElement) {
            domElement.classList.remove(className);
        }
    };
    // DOM helper shortcut functions
    core_1.st.hide = core_1.st.dom.hide;
    core_1.st.show = core_1.st.dom.show;
    core_1.st.addClass = core_1.st.dom.addClass;
    core_1.st.removeClass = core_1.st.dom.removeClass;
}
//# sourceMappingURL=dom.js.map